import React from 'react';
import ImageUploadBox from './ImageUploadBox';
import ImageThumbStrip from './ImageThumbStrip';
import { DOCUMENT_COMPRESSION_OPTIONS } from '../utils/helpers';

// The customer's payment receipt(s) when sales LINK a credit finance has
// already recorded (operator rule 2026-10-29: compulsory, stored as a SET the
// same way a Payment Received request's receipts are). Upload-first like the
// PR form: `urls` are already-uploaded images, `onChange(nextUrls)`.
// Used by every screen that links a bank credit to a customer.
export default function LinkReceiptsField({ urls, onChange, required, error }) {
  const list = Array.isArray(urls) ? urls : [];
  return (
    <div className="form-group">
      <ImageThumbStrip
        urls={list}
        onChange={onChange}
        endpoint="/upload/payment-proof"
        compressionOptions={DOCUMENT_COMPRESSION_OPTIONS}
        altPrefix="Receipt"
        removeTitle="Remove this receipt"
      />
      <ImageUploadBox
        endpoint="/upload/payment-proof"
        compressionOptions={DOCUMENT_COMPRESSION_OPTIONS}
        label={list.length ? "Add another customer receipt" : "Customer's payment receipt"}
        required={required && list.length === 0}
        currentUrl={''}
        onUploadSuccess={(url) => { if (url && !list.includes(url)) onChange([...list, url]); }}
        helperText={required
          ? 'Compulsory: the receipt the customer sent for this payment. Click, drag-drop or paste; you can add several images.'
          : 'The receipt the customer sent for this payment. Click, drag-drop or paste; you can add several images.'}
      />
      {error && <span className="error-message" style={{ display: 'block', marginTop: 4 }}>{error}</span>}
    </div>
  );
}
